import { addOns } from './discover';
import { AddOnVendors, ISVVendorsByLegacyName } from '@/types/addons';

export type AddonInformation = {
  icon: string;
  email: string;
  supportCenterDisplayName: string;
};

const addonInformation: Record<string, AddonInformation> = {
  [ISVVendorsByLegacyName.Malwarebytes]: {
    icon: addOns[AddOnVendors.ThreatDown].icon,
    email: 'mwbsupport@electric.ai',
    supportCenterDisplayName: 'ThreatDown',
  },
  [ISVVendorsByLegacyName.Perimeter81]: {
    icon: addOns[AddOnVendors.CheckPointHarmonySASE].icon,
    email: 'p81support@electric.ai',
    supportCenterDisplayName: 'Check Point Harmony SASE',
  },
  [ISVVendorsByLegacyName.Avanan]: {
    icon: addOns[AddOnVendors.CheckPointHarmonyEC].icon,
    email: 'avanansupport@electric.ai',
    supportCenterDisplayName: 'Check Point Harmony Email & Collaboration',
  },
};

export default addonInformation;
